import request from "@/config/_request";
import qs from "qs";
const admin = true;

//超管获得运营活动列表
export function activityList(params) {
    return request({
        url: "/api/admin/get/run/activity/list",
        params,
        method: "get",
        admin

    });
}
//超管更新或添加运营活动
export function addActivity(params) {
    return request({
        url: "/api/admin/add/or/update/run/activity",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}
//超管删除运营活动
export function delActivity(params) {
    return request({
        url: "/api/admin/delete/run/activity",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}
//超管更新运营活动置顶
export function topActivity(params) {
    return request({
        url: "/api/admin/update/run/activity/new/state",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}
//超管获得运营活动类型列表
export function typeList(params) {
    return request({
        url: "/api/get/run/activity/type/list",
        params,
        method: "get",
        admin

    });
}
//超管更新或添加运营活动类型
export function addType(params) {
    return request({
        url: "/api/admin/add/or/update/run/activity/type",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}
//超管删除运营活动类型
export function delType(params) {
    return request({
        url: "/api/admin/delete/run/activity/type",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}

//超管获得运营活动报名教师列表
export function uPactivityList(params) {
    return request({
        url: "/api/admin/get/run/activity/tch/list",
        params,
        method: "get",
        admin

    });
}

//超管获得运营培训列表
export function trainingList(params) {
    return request({
        url: "/api/admin/get/run/training/list",
        params,
        method: "get",
        admin

    });
}


//超管更新或添加运营培训
export function addTraining(params) {
    return request({
        url: "/api/admin/add/or/update/run/training",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}

//超管删除运营培训
export function delTraining(params) {
    return request({
        url: "/api/admin/delete/run/training",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}
//更新运营培训发布状态
export function isState(params) {
    return request({
        url: "/api/admin/update/run/training/post/state",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}

//获得运营培训章节
export function chapterList(params) {
    return request({
        url: "/api/admin/get/run/training/chapter/list",
        params,
        method: "get",
        admin

    });
}

//加或更新运营培训章节
export function addChapter(params) {
    return request({
        url: "/api/admin/add/or/update/run/training/chapter",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}
//删除运营培训章节
export function chapterDel(params) {
    return request({
        url: "/api/admin/delete/run/training/chapter",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}

//获得运营培训视频
export function videoList(params) {
    return request({
        url: "/api/admin/get/run/training/video/list",
        params,
        method: "get",
        admin

    });
}


//添加或更新运营培训视频
export function editVideo(params) {
    return request({
        url: "/api/admin/add/or/update/run/training/video",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}

//删除运营培训视频
export function delVideo(params) {
    return request({
        url: "/api/admin/delete/run/training/video",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}

//获得观看了运营培训的教师列表
export function readerList(params) {
    return request({
        url: "/api/admin/get/run/training/reader/list",
        params,
        method: "get",
        admin

    });
}











//超管获得运营培训类型列表
export function listType(params) {
    return request({
        url: "/api/get/run/training/type/list",
        params,
        method: "get",
        admin

    });
}
//addType超管更新或添加运营培训类型
export function typeAdd(params) {
    return request({
        url: "/api/admin/add/or/update/run/training/type",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}
//超管删除运营培训类型
export function typeDel(params) {
    return request({
        url: "/api/admin/delete/run/training/type",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}
// adminGetBaseMeterialTypeList  adminAddOrUpdateBaseMeterialType adminDeleteBaseMeterialType
//超管获得基础物料类型列表
export function materialList(params) {
    return request({
        url: "/api/admin/get/base/meterial/type/list",
        params,
        method: "get",
        admin

    });
}
//超管更新或添加物料类型
export function addMaterial(params) {
    return request({
        url: "/api/admin/add/or/update/base/meterial/type",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}
//删除基础物料类型
export function delMaterial(params) {
    return request({
        url: "/api/admin/delete/base/meterial/type",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}
//超管获得物料场景列表
export function sceneList(params) {
    return request({
        url: "/api/admin/get/base/meterial/scene/list",
        params,
        method: "get",
        admin

    });
}
//添加或更新使用场景类型
// base_meterial_scene_id
export function addScene(params) {
    return request({
        url: "/api/admin/add/or/update/base/meterial/scene",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}

//超管删除物料场景
// base_meterial_scene_id
export function delScene(params) {
    return request({
        url: "/api/admin/delete/base/meterial/scene",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}



//超管获取物料列表
export function baseMeterial(params) {
    return request({
        url: "/api/admin/get/base/meterial/list",
        params,
        method: "get",
        admin

    });
}

//添加或更新基础物料
export function addBaseMeterial(params) {
    return request({
        url: "/api/admin/add/or/update/base/meterial",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}

//超管删除基础物料
export function delBaseMeterial(params) {
    return request({
        url: "/api/admin/delete/base/meterial",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}
//超管更新物料发布状态
export function isMeterialState(params) {
    return request({
        url: "/api/admin/update/base/meterial/post/state",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}

//超管获得基础物料文件列表
export function fileList(params) {
    return request({
        url: "/api/admin/get/base/meterial/file/list",
        params,
        method: "get",
        admin

    });
}
//超管获得新增基础物料文件列表
export function addFileList(params) {
    return request({
        url: "/api/admin/add/or/update/base/meterial/file",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}

//超管删除基础物料文件
export function delFileList(params) {
    return request({
        url: "/api/admin/delete/base/meterial/file",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}

//获得运营培训文件列表
export function trainingFileList(params) {
    return request({
        url: "/api/admin/get/run/training/file/list",
        params,
        method: "get",
        admin

    });
}
//添加或更新运营培训文件
export function addTrainingFileList(params) {
    return request({
        url: "/api/admin/add/or/update/run/training/file",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}

//超管删除基础物料文件
export function delTrainingFileList(params) {
    return request({
        url: "/api/admin/delete/run/training/file",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}
//超管更新物料置顶等级
export function isTop(params) {
    return request({
        url: "/api/admin/update/base/meterial/new/state",
        data: qs.stringify(params),
        method: "post",
        admin

    });
}

